import * as z from "zod"

const passwordSchema = z
  .string()
  .min(8, "Password must be at least 8 characters")
const emailSchema = z.string().email("Invalid email")

export const signInWithPasswordSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
  captchaToken: z.string().optional(),
  next: z.string().optional(),
})

export type SignInWithPasswordData = z.infer<typeof signInWithPasswordSchema>

export const signUpWithPasswordSchema = signInWithPasswordSchema.extend({
  name: z.string().optional(),
})

export type SignUpWithPasswordData = z.infer<typeof signUpWithPasswordSchema>

// Only work with tokens and emails for now (can be extended to token hashes and phone if needed)
export const verifyOtpSchema = z.object({
  token: z.coerce
    .string<string>()
    .min(6, { error: "Your one-time password must be 6 characters" }),
  email: emailSchema,
  type: z.enum(["email", "recovery", "invite", "email_change", "magiclink"]),
  next: z.string().optional(),
})

export type VerifyOtpData = z.infer<typeof verifyOtpSchema>

export const forgotPasswordSchema = z.object({
  email: emailSchema,
})

export type ForgotPasswordData = z.infer<typeof forgotPasswordSchema>

export const updatePasswordSchema = z.object({
  password: passwordSchema,
})

export type UpdatePasswordData = z.infer<typeof updatePasswordSchema>
